<template>
  <transition name="t-fader">
    <div v-if="currentStep.text !== ''" class="onBoarding u-wrapper-panel u-pointer-none">
      <div v-if="currentStep.el === null" class="onBoarding__intro u-wrapper-panel u-pointer-all" @click="onStepEnd" />
      <svg v-else class="onBoarding__mask" :viewBox="`0 0 ${body.width} ${body.height}`">
        <mask id="mask">
          <rect x="0" y="0" :width="body.width" :height="body.height" fill="white"/>
          <rect :x="mask.x" :y="mask.y" :width="mask.width" :height="mask.height" fill="black" rx="10" ry="10"/>
        </mask>
        <rect x="0" y="0" :width="body.width" :height="body.height" fill="black" mask="url(#mask)"/>
      </svg>
      <div class="onBoarding__infos u-pointer-all u-bg-grey u-white" :width="infosWidth" :height="infosHeight" :style="{top: infos.y, left: infos.x, width: infos.width, height: infos.height}">
        <div class="onBoarding__infos__cross u-bg-grey u-absolute u-flex u-middle u-center u-round u-pointer" @click="onSkip">
          <img src="/images/cross.svg" alt="Cross icon" class="u-w3of8">
        </div>
        <div class="onBoarding__infos__title">
          {{ currentStep.text }}
        </div>
        <div class="onBoarding__infos__step">
          <!-- {{ $t('onBoarding.step') }} {{ stepNumber }} / {{steps.length}} -->
        </div>
        <div class="onBoarding__infos__actions u-w7of8 u-flex u-around">
          <app-button class="u-w4of8" :hasGradientBorder="true" :isBorderOrange="true" @click="onSkip">{{$t('button.skip')}}</app-button>
          <div v-if="currentStep.isNextBtn" class="onBoarding__infos__actions__cta u-inline-block u-w4of8">
            <app-button :hasGradient="true" @click.native="onStepEnd">{{$t('button.next')}}</app-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const baseState = {
  el: null,
  text: '',
  pad: {
    vert: 0,
    horz: 0
  },
  isNextBtn: false
}

export default {
  name: 'onBoarding',

  data () {
    return {
      body: {
        height: 0,
        width: 0
      },
      currentStep: { ...baseState },
      nextStep: { ...baseState },
      infosWidth: 400,
      infosHeight: 200
    }
  },

  computed: {
    steps () {
      return this.$store.getters['data/tutorials'] ? this.$store.getters['data/tutorials'] : []
    },
    mask () {
      if (this.currentStep.el === null) {
        return {
          height: 0,
          width: 0,
          x: 0,
          y: 0
        }
      }

      const offset = this.$offset.absolute(this.currentStep.el)
      const width = this.currentStep.el.offsetWidth + this.currentStep.pad.h
      const height = this.currentStep.el.offsetHeight + this.currentStep.pad.v

      return {
        height: height,
        width: width,
        x: offset.left - (this.currentStep.pad.h * 0.5),
        y: offset.top - (this.currentStep.pad.v * 0.5)
      }
    },

    infos () {

      let x = 0
      let y = 0

      if (this.$device.isMobile) {
        this.infosWidth = this.$device.width
        // height = this.infosHeight
        x = 0

        y = this.$device.height - this.infosHeight

        if (y < this.mask.y + this.mask.height) {
          y = this.mask.y - this.infosHeight
        }


      }
      else {
        if (this.currentStep.el === null) {
          return {
            width: this.infosWidth + 'px',
            height: this.infosHeight + 'px',
            x: (this.$device.width - this.infosWidth) * 0.5 + 'px',
            y: (this.$device.height - this.infosHeight) * 0.5 + 'px'
          }
        }

        const margin = 20

        x = this.mask.x + this.mask.width + margin
        let place = 'left'

        if (x + this.infosWidth > this.$device.width) {
          x = this.mask.x - this.infosWidth - margin
        }
        if (x < 0) {
          place = 'bottom'
          x = this.mask.x + .5 * (this.mask.width - this.infosWidth)
        }

        y = (this.mask.y + (this.mask.height - this.infosHeight) * 0.5)

        if (y + this.infosHeight > this.$device.height ) {
          y = this.$device.height - this.infosHeight
        }

        if (place === 'bottom') {
          y = this.mask.y + this.mask.height + margin
        }

        if (y < 0) {
          y = 10
        }
        else {

        }
      }

      return {
        width: this.infosWidth + 'px',
        height: this.infosHeight + 'px',
        x: x + 'px',
        y: y + 'px'
      }
    },

    stepNumber () {
      for (let i = 0; i < this.steps.length; i++) {
        if (this.currentStep.text === this.steps[i].text || this.currentStep.text === this.steps[i].mobileText) {
          return i + 1
        }
      }

      return 0
    }
  },

  mounted () {
    this.onResize()
    this.$hub.on('onBoarding:step', this.onStep)
    this.$hub.on('onBoarding:stepend', this.onStepEnd)
  },

  methods: {
    onResize () {
      const app = document.querySelector('#app')
      this.body.height = app.offsetHeight
      this.body.width = app.offsetWidth
    },
    onStep ({ el = null, step = null, pad = { v: 0, h: 0 }, isNextBtn = false, callback = ()=>{}, width = 400, height = 200 }) {
      if (step === null) return

      setTimeout(() => {
        if (this.currentStep.text !== '') {
          this.nextStep.text = this.$device.isTablet && step.mobileText ? step.mobileText : step.text
          this.nextStep.el = el
          this.nextStep.pad = pad
          this.nextStep.isNextBtn = isNextBtn
          this.nextStep.callback = callback
        } else {
          this.currentStep.text = this.$device.isTablet && step.mobileText ? step.mobileText : step.text
          this.currentStep.el = el
          this.currentStep.pad = pad
          this.currentStep.isNextBtn = isNextBtn
          this.currentStep.callback = callback
          this.infosWidth = width
          this.infosHeight = height
        }
      }, 500)
    },
    onStepEnd () {
      this.currentStep.callback()
      this.currentStep = Object.assign({}, this.currentStep, { ...baseState })
      if (this.nextStep.text !== '') {
        setTimeout(() => {
          this.currentStep = Object.assign({}, this.currentStep, this.nextStep)
          this.nextStep = Object.assign({}, this.nextStep, { ...baseState })
        }, 1000)
      } else {
        this.nextStep = Object.assign({}, this.nextStep, { ...baseState })
      }
    },
    onBardingEnd () {
      this.$emit('onBoardingFinished')
      this.$hub.off('onBoarding:step', this.onStep)
      this.$hub.off('onBoarding:stepend', this.onStepEnd)
    },
    onSkip () {
      this.currentStep = Object.assign({}, this.nextStep, { ...baseState })
      this.onBardingEnd()
    }
  },

  watch: {
    stepNumber (to, from) {
      if (from === this.steps.length) {
        this.onBardingEnd()
      }
    }
  }
}
</script>

<style lang="stylus">
.onBoarding
  z-index: 10000

  &__mask
    opacity .8

  &__intro
    &:before
      content ''
      position absolute
      top 0
      left 0
      width 100%
      height 100%
      display block
      background black
      opacity .5

  &__infos
    background white
    position absolute
    padding 25px
    border-radius: 15px
    
    &__cross
      top -20px
      left calc( 50% - 20px )
      height 40px
      width 40px

    &__title
      font-size 1.5em
      font-weight bold

    &__details
      font-size 1em
      color grey
      margin-top 20px
      line-height 1.3em

    &__step
      font-size 0.8em
      color grey
      position absolute
      bottom 25px
      left 25px

    &__actions
      font-size 0.8em
      color grey
      position absolute
      bottom 25px
      right 25px

      &__cta
        margin-left 10px
</style>
